export default "__VITE_ASSET__K3B0fT5V__"